export default __webpack_public_path__ + "static/media/change-link-img-cn.1ec40224.svg";